import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRings = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1795_1874)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M8 10.5C9.38071 10.5 10.5 9.38071 10.5 8C10.5 6.61929 9.38071 5.5 8 5.5C6.61929 5.5 5.5 6.61929 5.5 8C5.5 9.38071 6.61929 10.5 8 10.5Z",
				stroke: "black",
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8 6V4",
				stroke: "black",
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10 5.99L10.99 5",
				stroke: "black",
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10 8H12",
				stroke: "black",
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10 10.0098L10.99 10.9998",
				stroke: "black",
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8 10.3999V11.9999",
				stroke: "black",
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.99999 10L5.00999 10.99",
				stroke: "black",
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6 8H4",
				stroke: "black",
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.99999 5.99977L5.00999 5.00977",
				stroke: "black",
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.5 12V14.5H4",
				stroke: "black",
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4 12L1.5 14.5",
				stroke: "black",
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4 1.5H1.5V4",
				stroke: "black",
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4 4L1.5 1.5",
				stroke: "black",
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.5 4V1.5H12",
				stroke: "black",
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 4L14.5 1.5",
				stroke: "black",
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 14.5H14.5V12",
				stroke: "black",
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 12L14.5 14.5",
				stroke: "black",
				strokeLinejoin: "bevel"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1795_1874",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgRings;
